
import { Route } from 'config/routes';
import { DealType } from './entities';
import { Amenity } from 'components/filters/types';
import { amenitiesInvertedDict } from 'consts/dictionaries';
import { dealTypeInvertedDict } from 'consts/dictionaries';


export const buildSearchPathWithAmenity = (
  routeName: Route.Search | Route.SearchCommercial,
  amenity: Amenity,
  dealType: DealType,
  term: string
) => {
  const dealTypeFromDict = dealTypeInvertedDict[dealType];

  let path: string;
  switch (routeName) {
    case Route.Search:
      path = `/for-${dealTypeFromDict}/${term}/${amenitiesInvertedDict[amenity]}`;
      break;
    case Route.SearchCommercial:
      path = `/commercial/for-${dealTypeFromDict}/${term}/${amenitiesInvertedDict[amenity]}`;
      break;
  }

  return encodeURI(path);
};
